import React from "react";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const C = { primary: "#5C162E", secondary: "#C7386B", accent: "#D4AF37", bg: "#FBEEF0" };

export default function Login() {
  const { login } = useAuth();
  const params = new URLSearchParams(window.location.search);
  const error = params.get("error");

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: C.bg }}>
      <div className="w-full max-w-sm text-center flex flex-col gap-5 rounded-3xl bg-white/70 backdrop-blur-xl p-8 shadow-xl" style={{ border: `1px solid ${C.primary}22` }} data-testid="login-page">
        <Lock className="mx-auto" size={30} style={{ color: C.primary }} />
        <h1 className="text-3xl" style={{ color: C.primary, fontFamily: "'Cormorant Garamond', serif" }}>Publisher Login</h1>
        <p className="text-sm text-neutral-500">Sign in to manage your invitation and view RSVP responses. Guests can view the invitation without signing in.</p>
        {error === "unauthorized" && (
          <p className="text-sm rounded-lg px-3 py-2" style={{ background: "#fdecef", color: "#b02a4a" }} data-testid="login-error">This Google account is not authorized to manage this invitation.</p>
        )}
        {error === "failed" && (
          <p className="text-sm rounded-lg px-3 py-2" style={{ background: "#fdecef", color: "#b02a4a" }} data-testid="login-error">Sign-in failed. Please try again.</p>
        )}
        <button data-testid="google-login-btn" onClick={login} className="rounded-xl py-3 text-white font-body tracking-wide text-sm flex items-center justify-center gap-2" style={{ background: C.primary }}>
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" width={18} height={18} style={{ background: "#fff", borderRadius: 3, padding: 1 }} />
          Sign in with Google
        </button>
        <a href="/" className="text-xs text-neutral-500 underline" data-testid="back-to-invitation">← Back to invitation</a>
      </div>
    </div>
  );
}
